import client from "../api-client";

const URL = "countries.php";

export const get = async () => {
  return await client(URL);
};
